import moment from 'moment';
import React, { FC, useEffect, useState } from 'react';
import { Button, Checkbox, Col, DatePicker, Form, Input, message, Radio, Row, Select, Spin, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import RegistrationWidget from 'src/components/dashboard/common-widget/registration-widget/registration-widget';
import TitleBox from 'src/components/title-box/title-box';
import { i18nKey } from 'src/locales/i18n';
import OnboardingPage from '../onboarding';
import styles from './individual-account-detail.module.less';
import QuitConfirmPopup from 'src/components/registration/quit-confirmer/quit-confirm-popup';
import { useNavigate } from 'react-router-dom';
import { PAGE_ROUTE } from 'src/constants/route';
import useStore from 'src/hooks/useStore';
import {
	CHINA_NATIONALITY_VALUE,
	DEAFULT_COUNTRY_CODE_CHINESE,
	EMPLOYMENT_TYPE_CODE,
	HONG_KONG_NATIONALITY_VALUE,
	OCCUPATION_LISTS,
	ONBOARDING_TYPE,
	OTHER_VALUE_TYPE
} from 'src/constants';
import { observer } from 'mobx-react-lite';
import { IAccountDetail } from 'src/interfaces/accounts/account';
import { IApplicationStore } from 'src/store/root/application.store';
import { IUserStore } from 'src/store/user';

import { IBaseOnboardingStore, IOnboardingStore } from 'src/store/user/onboarding.store';
import { RootStoreChildType } from 'src/store/root/root.store';
import {
	isHkIdValid,
	normalizeHkCheckDigitPart,
	normalizeHkIdFirstPart,
	normalizeHkIdPart,
	normalizeInputBlockCharacter,
	normalizeInputBlockNumber,
	normalizeInputBlockNumberAndAllowChineseCharacter,
	normalizeNumberInput
} from 'src/helpers/common.utils';
import CountryDistrictSection from 'src/components/country-district-section/country-district-section';
import { RangePickerProps } from 'antd/lib/date-picker';
import NumberInput from 'src/components/input-with-number/input-with-number';
import {
	MAXIMUM_LIVED_YEAR_REGEX,
	LETTER_REGEX,
	NUMBER_REGEX,
	ZIPCODE_REGEX,
	CHINESE_ID_LENGTH,
	CHINESE_MOBILE_LENGTH
} from 'src/constants/validation';
import { checkChineseCharacters, checkLengthCharacters, isValidPassport } from 'src/utils/common.utils';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

const IndividualAccountPage: FC = () => {
	const [isMandatoryChineseId, setMandatoryChineseId] = useState<boolean>(false);

	const [isMandatoryHkId, setMandatoryHkId] = useState<boolean>(false);

	const [isMandatoryPassport, setMandatoryPassport] = useState<boolean>(false);

	const [disableZipCode, setDisableZipCode] = useState(false);
	const [disableZipCodeEmployerDetail, setDisableZipCodeEmployerDetail] = useState(false);
	const [disableMailingZipCode, setDisableMailingZipCode] = useState(false);
	const [isRequireChineseName, setRequireChineseName] = useState<boolean>(false);
	const [isChineseNationality, setChineseNationality] = useState<boolean>(false);

	const [isShowEmploymentStatusOther, setIsShowEmploymentStatusOther] = useState<boolean>(false);
	const [isChooseRetiredOption, setIsChooseRetiredOption] = useState<boolean>(false);
	const [isShowOtherOccupation, setIsShowOtherOccupation] = useState<boolean>(false);

	const onboardingStore: IOnboardingStore = useStore('onboardingStore');
	const applicationStore: IApplicationStore = useStore('applicationStore');
	const userStore: IUserStore = useStore('userStore');

	const onboardingStoreHandler: RootStoreChildType =
		onboardingStore.onboardingType == ONBOARDING_TYPE.FUNDER
			? 'individualFunderOnboardingStore'
			: 'individualBorrowerOnboardingStore';

	const baseOnboardingStore: IBaseOnboardingStore = useStore(onboardingStoreHandler);

	const [saving, setSaving] = useState(false);
	const [quitModalOpen, setQuitModalOpen] = useState(false);

	const [isOpenOtherMaritalStatus, setOtherMaritalStatusInput] = useState(false);

	const [isOpenOtherTitle, setOpenOtherTitle] = useState(false);

	const [isOpenOtherSourceOfFunds, setOpenOtherSourceOfFunds] = useState(false);

	const [t] = useTranslation();
	const navigator = useNavigate();

	const [accountForm] = Form.useForm();
	const onOccupationChange = (e: string) => {
		if (e == OTHER_VALUE_TYPE.OTHERS_VALUE) {
			setIsShowOtherOccupation(true);
		} else {
			setIsShowOtherOccupation(false);
		}
	};
	const renderOccupation = () => {
		if (isShowOtherOccupation) {
			return (
				<>
					<Col xs={24} sm={24} md={24} lg={12}>
						<Form.Item
							required={!isChooseRetiredOption}
							label={`${t(i18nKey.onboarding.request.employment.occupation)}`}>
							<Row gutter={10}>
								<Col span={12}>
									<Form.Item
										noStyle
										name={['employmentDetail', 'occupation']}
										required={false}
										rules={[
											{
												validator: (_, values) => {
													if (!values && !isChooseRetiredOption) {
														return Promise.reject(`${t(i18nKey.onboarding.validation.required)}`);
													}
													return Promise.resolve();
												}
											}
										]}>
										<Select
											placeholder={`${t(i18nKey.common.select)}`}
											options={OCCUPATION_LISTS}
											onChange={onOccupationChange}
											disabled={isChooseRetiredOption}
										/>
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item
										name={['employmentDetail', 'occupationOther']}
										required={false}
										rules={
											[
												{
													validator: (_, values) => {
														if (!values && !isChooseRetiredOption) {
															return Promise.reject(`${t(i18nKey.onboarding.validation.required)}`);
														}
														return Promise.resolve();
													}
												}
											]
											// [

											// 	{
											// 		required: onboardStore.employmentDetail?.occupation === OTHER_VALUE_TYPE.OTHERS_VALUE
											// 			? true : false,
											// 		message: `${t(i18nKey.onboarding.validation.required)}`
											// 	}
											// ]
										}>
										<Input disabled={isChooseRetiredOption} />
									</Form.Item>
								</Col>
							</Row>
						</Form.Item>
					</Col>
				</>
			);
		}
		return (
			<>
				<Col xs={24} sm={24} md={24} lg={12}>
					<Form.Item
						name={['employmentDetail', 'occupation']}
						label={`${t(i18nKey.onboarding.request.employment.occupation)}`}
						required={!isChooseRetiredOption}
						rules={[
							{
								validator: (_, values) => {
									if (!values && !isChooseRetiredOption) {
										return Promise.reject(`${t(i18nKey.onboarding.validation.required)}`);
									}
									return Promise.resolve();
								}
							}
						]}>
						<Select
							placeholder={`${t(i18nKey.common.select)}`}
							options={OCCUPATION_LISTS}
							onChange={onOccupationChange}
							disabled={isChooseRetiredOption}
						/>
					</Form.Item>
				</Col>
			</>
		);
	};

	useEffect(() => {
		setSaving(true);
		baseOnboardingStore.loadProgress().then(() => {
			setSaving(false);
			accountForm.setFieldsValue({
				...baseOnboardingStore.accountDetail
			});
		});
	}, []);

	useEffect(() => {
		if (baseOnboardingStore.accountDetail?.residentialAddress?.country === 'HK') {
			setDisableZipCode(true);
		}

		if (baseOnboardingStore.accountDetail?.mailingAddress?.country === 'HK') {
			setDisableMailingZipCode(true);
		}
		if (baseOnboardingStore.accountDetail?.employmentDetail?.country === 'HK') {
			setDisableZipCodeEmployerDetail(true);
		}

		// switch (baseOnboardingStore?.accountDetail?.nationality) {
		// 	case HONG_KONG_NATIONALITY_VALUE:
		// 		setMandatoryHkId(true);
		// 		setMandatoryPassport(false);
		// 		setMandatoryChineseId(false);
		// 		setChineseNationality(false);
		// 		break;
		// 	case CHINA_NATIONALITY_VALUE:
		// 		setMandatoryChineseId(true);
		// 		setMandatoryHkId(false);
		// 		setMandatoryPassport(false);
		// 		setChineseNationality(true);
		// 		break;
		// 	case undefined:
		// 		setMandatoryChineseId(false);
		// 		setMandatoryHkId(false);
		// 		setMandatoryPassport(false);
		// 		break;
		// 	default:
		// 		setMandatoryPassport(true);
		// 		setMandatoryChineseId(false);
		// 		setMandatoryHkId(false);
		// 		setChineseNationality(false);
		// 		break;
		// }
	}, [baseOnboardingStore.accountDetail]);

	const onFormFinish = async (values: IAccountDetail) => {
		const rs = await baseOnboardingStore.saveAccountDetail({
			...values
		});
		setSaving(false);
		if (rs) {
			message.success(t(i18nKey.feedback.saveAccountSuccess));
			if (onboardingStore.onboardingType === ONBOARDING_TYPE.FUNDER) {
				navigator(PAGE_ROUTE.FUNDER_REQUEST_FORM);
			} else {
				navigator(PAGE_ROUTE.BORROWER_ACCOUNT_FORM);
			}
		}
	};

	const onFormFailed = () => {
		const firstInvalidFormItem = accountForm.getFieldsError()[0];
		if (firstInvalidFormItem) {
			accountForm.scrollToField(firstInvalidFormItem.name[0], {
				behavior: 'smooth'
			});
		}
		setSaving(false);
	};
	const onSaveClick = async () => {
		setSaving(true);
		accountForm.submit();
	};

	const onCancelClick = () => {
		setQuitModalOpen(true);
	};

	const onModalClose = () => {
		setQuitModalOpen(false);
	};

	const onModalQuit = () => {
		setQuitModalOpen(false);
		navigator(PAGE_ROUTE.DASHBOARD);
	};

	const onChangeNationality = (value: string) => {
		switch (value) {
			case HONG_KONG_NATIONALITY_VALUE:
				setMandatoryHkId(true);
				setMandatoryPassport(false);
				setMandatoryChineseId(false);
				setRequireChineseName(false);
				setChineseNationality(false);
				break;
			case CHINA_NATIONALITY_VALUE:
				setMandatoryChineseId(true);
				setMandatoryHkId(false);
				setMandatoryPassport(false);
				setRequireChineseName(true);
				setChineseNationality(true);
				accountForm.setFieldValue('gender', undefined);
				accountForm.setFieldValue('mobilePhoneCountryCode', DEAFULT_COUNTRY_CODE_CHINESE);
				break;
			default:
				setMandatoryPassport(true);
				setMandatoryChineseId(false);
				setMandatoryHkId(false);
				setRequireChineseName(false);
				setChineseNationality(false);
				accountForm.setFieldValue('mobilePhoneCountryCode', null);
				break;
		}
	};

	const onChangeEmploymentStatus = (e: CheckboxChangeEvent) => {
		setIsShowEmploymentStatusOther(e.target.value === EMPLOYMENT_TYPE_CODE.others);
		setIsChooseRetiredOption(e.target.value === EMPLOYMENT_TYPE_CODE.retired);
		if (e.target.value === EMPLOYMENT_TYPE_CODE.retired) {
			accountForm.resetFields([
				['employmentDetail', 'employerName'],
				['employmentDetail', 'natureOfBusiness'],
				['employmentDetail', 'employerPhoneExtension'],
				['employmentDetail', 'employmentType'],
				['employmentDetail', 'employmentTypeOther'],
				['employmentDetail', 'employerPhone'],
				['employmentDetail', 'annualSalary'],
				['employmentDetail', 'addressLine'],
				['employmentDetail', 'district'],
				['employmentDetail', 'zipCode'],
				['employmentDetail', 'street'],
				['employmentDetail', 'country'],
				['employmentDetail', 'occupationOther'],
				['employmentDetail', 'occupation']
			]);
			setIsShowEmploymentStatusOther(false);
			setIsShowOtherOccupation(false);
		}
		accountForm.setFieldValue('employmentTypeOther', undefined);
	};

	const disabledDate: RangePickerProps['disabledDate'] = (current) => {
		return current && current > moment().subtract(18, 'years').endOf('day');
	};

	const disabledExpiryDate: RangePickerProps['disabledDate'] = (current) => {
		const effectiveDate = accountForm.getFieldValue('chineseIdEffectiveDate');
		return current && current <= moment(effectiveDate).endOf('day');
	};

	const checkDisableZipCode = (values: IAccountDetail) => {
		setDisableZipCode(values.residentialAddress?.country === 'HK');
		setDisableMailingZipCode(values.mailingAddress?.country === 'HK');
		setDisableZipCodeEmployerDetail(values.employmentDetail?.country === 'HK');
	};

	const onChangeValuesForm = (_: string, values: IAccountDetail) => {
		checkDisableZipCode(values);
		if (values.maritalStatus === OTHER_VALUE_TYPE.OTHER_VALUE) {
			setOtherMaritalStatusInput(true);
		} else {
			accountForm.setFieldValue('otherMaritalStatus', undefined);
			setOtherMaritalStatusInput(false);
		}

		if (values.title === OTHER_VALUE_TYPE.OTHERS_VALUE) {
			setOpenOtherTitle(true);
		} else {
			accountForm.setFieldValue('otherTitle', undefined);
			setOpenOtherTitle(false);
		}

		if (values.sourceOfFunds?.includes(OTHER_VALUE_TYPE.OTHER_SOURCE_OF_FUNDS)) {
			setOpenOtherSourceOfFunds(true);
		} else {
			setOpenOtherSourceOfFunds(false);
		}

		if (values.residentialAddress?.country === 'HK') {
			setDisableZipCode(true);
		} else setDisableZipCode(false);

		if (values.mailingAddress?.country === 'HK') {
			setDisableMailingZipCode(true);
		} else setDisableMailingZipCode(false);
	};

	const renderMaritalStatus = () => {
		if (isOpenOtherMaritalStatus) {
			return (
				<>
					<Col xs={24} sm={24} md={24} lg={12}>
						<Form.Item required={true} label={`${t(i18nKey.dashboard.accountInformation.maritalStatus)}`}>
							<Row gutter={10}>
								<Col span={12}>
									<Form.Item
										noStyle
										name="maritalStatus"
										label={`${t(i18nKey.dashboard.accountInformation.maritalStatus)}`}>
										<Select placeholder={`${t(i18nKey.common.select)}`} options={applicationStore.maritalStatuses} />
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item
										name="otherMaritalStatus"
										required={false}
										rules={[
											{
												required: isOpenOtherMaritalStatus,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<Input />
									</Form.Item>
								</Col>
							</Row>
						</Form.Item>
					</Col>
				</>
			);
		}

		return (
			<>
				<Col xs={24} sm={24} md={24} lg={12}>
					<Form.Item
						name="maritalStatus"
						label={`${t(i18nKey.dashboard.accountInformation.maritalStatus)}`}
						required={true}
						rules={[
							{
								required: true,
								message: `${t(i18nKey.onboarding.validation.required)}`
							}
						]}>
						<Select placeholder={`${t(i18nKey.common.select)}`} options={applicationStore.maritalStatuses} />
					</Form.Item>
				</Col>
			</>
		);
	};

	const onChangeTitle = (title: string) => {
		accountForm.resetFields(['gender']);
		baseOnboardingStore.updateTitle(title);
		if (
			![CHINA_NATIONALITY_VALUE, HONG_KONG_NATIONALITY_VALUE, undefined].includes(
				accountForm.getFieldValue('nationality')
			)
		) {
			setMandatoryPassport(true);
		}
	};

	const renderTitle = () => {
		if (isOpenOtherTitle) {
			return (
				<>
					<Col xs={12} sm={12} md={12} lg={12}>
						<Form.Item required={true} label={`${t(i18nKey.dashboard.accountInformation.title)}`}>
							<Row gutter={10}>
								<Col span={12}>
									<Form.Item
										noStyle
										name="title"
										required={false}
										rules={[
											{
												required: true,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<Select
											placeholder={`${t(i18nKey.common.select)}`}
											options={applicationStore.titleOptions}
											onChange={onChangeTitle}
										/>
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item
										name="titleOther"
										required={false}
										rules={[
											{
												required: isOpenOtherTitle,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<Input />
									</Form.Item>
								</Col>
							</Row>
						</Form.Item>
					</Col>
				</>
			);
		}

		return (
			<>
				<Col xs={24} sm={24} md={24} lg={12}>
					<Form.Item
						name="title"
						label={`${t(i18nKey.dashboard.accountInformation.title)}`}
						required={true}
						rules={[
							{
								required: true,
								message: `${t(i18nKey.onboarding.validation.required)}`
							}
						]}>
						<Select
							placeholder={`${t(i18nKey.common.select)}`}
							options={applicationStore.titleOptions}
							onChange={onChangeTitle}
						/>
					</Form.Item>
				</Col>
			</>
		);
	};

	return (
		<OnboardingPage>
			<RegistrationWidget title={`${t(i18nKey.onboarding.funder.accountTitle)}`}>
				<TitleBox>
					<span>{t(i18nKey.dashboard.accountInformation.personalDetail)}</span>
				</TitleBox>
				<Spin spinning={saving}>
					<Form
						onValuesChange={onChangeValuesForm}
						form={accountForm}
						layout={'vertical'}
						onFinish={onFormFinish}
						onFinishFailed={onFormFailed}
						initialValues={{
							...baseOnboardingStore.accountDetail,
							...userStore
						}}>
						<div className={styles.subLevelForm}>
							<Row gutter={[32, 16]}>
								{renderTitle()}
								<Col xs={24} sm={24} md={24} lg={12}>
									<Form.Item
										name="firstName"
										normalize={normalizeInputBlockNumber}
										label={`${t(i18nKey.registration.firstName)}`}
										rules={[
											{
												pattern: LETTER_REGEX,
												message: `${t(i18nKey.registration.validation.inputOnlyAlphabet)}`
											}
										]}>
										<Input placeholder="-" disabled />
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={[32, 16]}>
								<Col xs={24} sm={24} md={24} lg={12}>
									<Form.Item
										name="middleName"
										normalize={normalizeInputBlockNumber}
										label={`${t(i18nKey.registration.middleName)}`}
										rules={[
											{
												pattern: LETTER_REGEX,
												message: `${t(i18nKey.registration.validation.inputOnlyAlphabet)}`
											}
										]}>
										<Input placeholder="-" disabled />
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={24} lg={12}>
									<Form.Item
										name="lastName"
										normalize={normalizeInputBlockNumber}
										label={`${t(i18nKey.registration.lastName)}`}
										rules={[
											{
												pattern: LETTER_REGEX,
												message: `${t(i18nKey.registration.validation.inputOnlyAlphabet)}`
											}
										]}>
										<Input placeholder="-" disabled />
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={[32, 16]}>
								<Col xs={24} sm={24} md={24} lg={12}>
									<Form.Item
										name="nationality"
										label={`${t(i18nKey.dashboard.accountInformation.nationality)}`}
										required={true}
										rules={[
											{
												required: true,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<Select
											onChange={onChangeNationality}
											placeholder={`${t(i18nKey.common.select)}`}
											options={applicationStore.nationalities}
											showSearch
											filterOption={(input, option) =>
												new RegExp(`^${input.toLowerCase().trim()}`).test((option?.label ?? '').toLowerCase())
											}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={24} lg={12}>
									<Form.Item
										name="chineseName"
										normalize={normalizeInputBlockNumberAndAllowChineseCharacter}
										label={`${t(i18nKey.dashboard.accountInformation.chineseName)}`}
										required={isRequireChineseName}
										rules={[
											{
												required: isRequireChineseName,
												message: `${t(i18nKey.onboarding.validation.required)}`
											},
											{
												validator: checkChineseCharacters
											}
										]}>
										<Input />
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={[32, 16]}>
								<Col xs={24} sm={24} md={24} lg={12}>
									<Form.Item
										name="dob"
										label={`${t(i18nKey.dashboard.accountInformation.dob)}`}
										required={true}
										rules={[
											{
												type: 'object' as const,
												required: true,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<DatePicker disabledDate={disabledDate} placeholder="Select Date" className={styles.date} />
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={24} lg={12}>
									<Form.Item
										name="placeOfBirth"
										label={`${t(i18nKey.dashboard.accountInformation.pob)}`}
										required={true}
										rules={[
											{
												required: true,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<Select
											placeholder={`${t(i18nKey.common.select)}`}
											options={applicationStore.listOfCountry}
											showSearch
											filterOption={(input, option) =>
												new RegExp(`^${input.toLowerCase().trim()}`).test((option?.label ?? '').toLowerCase())
											}
										/>
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={[32, 16]}>
								<Col xs={24} sm={24} md={24} lg={12}>
									<Form.Item
										name="gender"
										label={`${t(i18nKey.dashboard.accountInformation.gender)}`}
										required={true}
										rules={[
											{
												required: true,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<Select
											placeholder={`${t(i18nKey.common.select)}`}
											allowClear
											options={applicationStore.filterGenderByTitle(
												isChineseNationality,
												baseOnboardingStore.accountDetail?.title as string
											)}
										/>
									</Form.Item>
								</Col>
								{isMandatoryHkId && (
									<Col xs={24} sm={24} md={24} lg={12}>
										<Form.Item required={isMandatoryHkId} label={`${t(i18nKey.dashboard.accountInformation.hkId)}`}>
											<Row align="middle" gutter={16}>
												<Col span={6}>
													<Form.Item
														name="hkIdPart1"
														noStyle
														dependencies={['hkId', 'hkIdPart2']}
														normalize={normalizeHkIdFirstPart}
														required={true}
														rules={[
															(fInstance) => ({
																validator() {
																	if (
																		!fInstance.getFieldValue('hkIdPart1') &&
																		!fInstance.getFieldValue('hkId') &&
																		!fInstance.getFieldValue('hkIdPart2')
																	) {
																		return Promise.reject(`${t(i18nKey.onboarding.validation.required)}`);
																	}
																	if (!isHkIdValid(fInstance, 'hkIdPart1', 'hkId', 'hkIdPart2')) {
																		return Promise.reject(
																			new Error(
																				`${t(i18nKey.onboarding.validation.accountDetail.required.hkIDNoFormat)}`
																			)
																		);
																	}
																	return Promise.resolve();
																}
															})
														]}>
														<Input
														// onChange={(e) => {
														// 	if (!e.target.value) {
														// 		setMandatoryHkId(false);
														// 	} else {
														// 		setMandatoryHkId(true);
														// 	}
														// }}
														/>
													</Form.Item>
												</Col>
												<Col xs={12} sm={12} md={12}>
													<Form.Item
														name="hkId"
														dependencies={['hkIdPart1', 'hkIdPart2']}
														noStyle
														required={false}
														normalize={normalizeHkIdPart}>
														<Input
														// onChange={(e) => {
														// 	if (!e.target.value) {
														// 		setMandatoryHkId(false);
														// 	} else {
														// 		setMandatoryHkId(true);
														// 	}
														// }}
														/>
													</Form.Item>
												</Col>
												<Col span={6}>
													<Row align="middle">
														<Col xs={2} sm={2} md={1}>
															<span>{'('}</span>
														</Col>
														<Col xs={21} sm={21} md={21}>
															<Form.Item name="hkIdPart2" noStyle normalize={normalizeHkCheckDigitPart}>
																<Input
																// onChange={(e) => {
																// 	if (!e.target.value) {
																// 		setMandatoryHkId(false);
																// 	} else {
																// 		setMandatoryHkId(true);
																// 	}
																// }}
																/>
															</Form.Item>
														</Col>
														<Col xs={1} sm={1} md={1}>
															<span>{')'}</span>
														</Col>
													</Row>
												</Col>
											</Row>
										</Form.Item>
									</Col>
								)}
								{isMandatoryChineseId && (
									<Col xs={24} sm={24} md={24} lg={12}>
										<Form.Item
											name="chineseIdNo"
											label={`${t(i18nKey.dashboard.accountInformation.chineseId)}`}
											required={isMandatoryChineseId}
											normalize={normalizeInputBlockCharacter}
											rules={[
												() => ({
													validator(_, value) {
														if (!value && isMandatoryChineseId) {
															return Promise.reject(new Error(`${t(i18nKey.onboarding.validation.required)}`));
														}
														return Promise.resolve();
													}
												}),
												() => ({
													validator(_, value) {
														return checkLengthCharacters(value, CHINESE_ID_LENGTH, isChineseNationality);
													}
												})
											]}>
											<Input />
										</Form.Item>
									</Col>
								)}
								{isMandatoryPassport && (
									<Col xs={24} sm={24} md={24} lg={12}>
										<Form.Item
											name="passportNo"
											label={`${t(i18nKey.dashboard.accountInformation.passport)}`}
											required={isMandatoryPassport}
											rules={[
												{
													required: isMandatoryPassport,
													message: `${t(i18nKey.onboarding.validation.required)}`
												},
												() => ({
													validator(_, value) {
														if (!value) return Promise.resolve();
														if (value && !isValidPassport(value)) {
															return Promise.reject(new Error('Incorrect passport No.'));
														}
														return Promise.resolve();
													}
												})
											]}>
											<Input />
										</Form.Item>
									</Col>
								)}
								{isChineseNationality && (
									<>
										<Col xs={24} sm={24} md={24} lg={12}>
											<Form.Item
												name="chineseIdEffectiveDate"
												label={`${t(i18nKey.dashboard.accountInformation.chineseIdEffectiveDate)}`}
												rules={[
													{
														required: isMandatoryChineseId,
														message: `${t(i18nKey.onboarding.validation.required)}`
													}
												]}>
												<DatePicker placeholder="Select Date" className={styles.date} />
											</Form.Item>
										</Col>
										<Col xs={24} sm={24} md={24} lg={12}>
											<Form.Item
												name="chineseIdExpiryDate"
												label={`${t(i18nKey.dashboard.accountInformation.chineseIdExpiryDate)}`}
												rules={[
													{
														required: isMandatoryChineseId,
														message: `${t(i18nKey.onboarding.validation.required)}`
													}
												]}>
												<DatePicker
													placeholder="Select Date"
													className={styles.date}
													disabledDate={disabledExpiryDate}
												/>
											</Form.Item>
										</Col>
										<Col xs={24} sm={24} md={24} lg={12}>
											<Form.Item
												name="chineseIDRegistrationAddress"
												label={`${t(i18nKey.dashboard.accountInformation.chineseIDRegistrationAddress)}`}
												rules={[
													{
														required: isChineseNationality,
														message: `${t(i18nKey.onboarding.validation.required)}`
													},
													{
														validator: checkChineseCharacters
													}
												]}>
												<Input />
											</Form.Item>
										</Col>
										<Col xs={24} sm={24} md={24} lg={12}>
											<Form.Item
												name="bankCardNumber"
												label={`${t(i18nKey.dashboard.accountInformation.bankCardNumber)}`}
												rules={[
													{
														required: isChineseNationality,
														message: `${t(i18nKey.onboarding.validation.required)}`
													},
													{
														pattern: NUMBER_REGEX,
														message: `${t(i18nKey.onboarding.validation.inputOnlyNumberCharacters)}`
													}
												]}>
												<Input />
											</Form.Item>
										</Col>
									</>
								)}
								<Col xs={24} sm={24} md={24} lg={12}>
									<Form.Item
										name="countryTaxResidence"
										label={`${t(i18nKey.dashboard.accountInformation.countryOfTax)}`}
										required={true}
										rules={[
											{
												required: true,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<Select
											placeholder={`${t(i18nKey.common.select)}`}
											options={applicationStore.listOfCountry}
											showSearch
											filterOption={(input, option) =>
												new RegExp(`^${input.toLowerCase().trim()}`).test((option?.label ?? '').toLowerCase())
											}
										/>
									</Form.Item>
								</Col>
								{renderMaritalStatus()}
							</Row>

							<Form.Item
								className={styles.formSourceOfFunds}
								name="sourceOfFunds"
								label={`${t(i18nKey.dashboard.accountInformation.sourceOfFunds)}`}
								required={true}
								rules={[
									{
										required: true,
										message: `${t(i18nKey.onboarding.validation.required)}`
									}
								]}>
								<Checkbox.Group style={{ width: '100%' }}>
									<Row gutter={[16, 16]} align="middle">
										<Col xxl={4} xl={6} md={12} xs={24} className={styles.alignMiddle}>
											<Checkbox value={'1'}>Investment Income</Checkbox>
										</Col>
										<Col xxl={4} xl={6} md={12} xs={24} className={styles.alignMiddle}>
											<Checkbox value={'2'}>Business Income</Checkbox>
										</Col>
										<Col xxl={3} xl={6} md={12} xs={24} className={styles.alignMiddle}>
											<Checkbox value={'3'}>Salary</Checkbox>
										</Col>
										<Col xxl={4} xl={6} md={12} xs={24} className={styles.alignMiddle}>
											<Checkbox value={'4'}>Director Fee</Checkbox>
										</Col>
										<Col xxl={4} xl={6} md={12} xs={24} className={styles.alignMiddle}>
											<Checkbox value={'5'}>Dividend</Checkbox>
										</Col>
										<Col xxl={5} xl={6} md={12} xs={24} className={styles.alignMiddle}>
											<Row wrap={false} align={'middle'}>
												<Checkbox value={'6'}>Others</Checkbox>

												{isOpenOtherSourceOfFunds && (
													<>
														<Col flex={'0 0 150px'} className={styles.alignMiddle}>
															<Form.Item
																noStyle
																name="otherSourceOfFunds"
																rules={[
																	{
																		required: isOpenOtherSourceOfFunds,
																		message: `${t(i18nKey.onboarding.validation.required)}`
																	}
																]}>
																<Input disabled={!isOpenOtherSourceOfFunds} />
															</Form.Item>
														</Col>
													</>
												)}
											</Row>
										</Col>
									</Row>
								</Checkbox.Group>
							</Form.Item>
						</div>
						<TitleBox style={{ backgroundColor: '#2CA6B8', color: '#FFFFFF' }}>
							<span>{t(i18nKey.dashboard.accountInformation.contactDetail)}</span>
						</TitleBox>
						<div className={styles.subLevelForm}>
							<Row gutter={[32, 16]}>
								<Col xs={24} sm={24} md={24} lg={12}>
									<Form.Item required={false} label={`${t(i18nKey.dashboard.accountInformation.officePhoneNo)}`}>
										<Row gutter={[16, 16]}>
											<Col xs={9} sm={9} md={6} lg={11} xl={9} xxl={7}>
												<Form.Item name={'officePhoneCountryCode'} required={false}>
													<Select
														placeholder={`${t(i18nKey.common.select)}`}
														options={applicationStore.phoneCountryCode}
														showSearch
														filterOption={(input, option) =>
															(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
														}
													/>
												</Form.Item>
											</Col>
											<Col xs={15} sm={15} md={18} lg={13} xl={15} xxl={17}>
												<NumberInput
													name={'officePhone'}
													// rules={[
													// 	{
													// 		required: true,
													// 		message: `${t(i18nKey.onboarding.validation.required)}`
													// 	}
													// ]}
												/>
											</Col>
										</Row>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={24} lg={12}>
									<div>
										<Typography.Text className="styleLabelForm">
											{`${t(i18nKey.dashboard.accountInformation.mobilePhone)}`}
											<span style={{ color: 'red' }}>*</span>
										</Typography.Text>
										<Row gutter={[16, 16]}>
											<Col xs={9} sm={9} md={6} lg={11} xl={9} xxl={7}>
												<Form.Item
													name={'mobilePhoneCountryCode'}
													rules={[
														{
															required: true,
															message: `${t(i18nKey.onboarding.validation.required)}`
														}
													]}
													required={false}>
													<Select
														placeholder={`${t(i18nKey.common.select)}`}
														options={applicationStore.phoneCountryCode}
														disabled={isChineseNationality}
														showSearch
														filterOption={(input, option) =>
															(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
														}
													/>
												</Form.Item>
											</Col>
											<Col xs={15} sm={15} md={18} lg={13} xl={15} xxl={17}>
												<NumberInput
													noStyle={false}
													name={'mobilePhone'}
													rules={[
														{
															required: true,
															message: `${t(i18nKey.onboarding.validation.required)}`
														},
														() => ({
															validator(_, value) {
																return checkLengthCharacters(value, CHINESE_MOBILE_LENGTH, isChineseNationality);
															}
														})
													]}
												/>
											</Col>
										</Row>
									</div>
								</Col>
							</Row>
						</div>

						<div className={styles.subLevelForm}>
							<Row gutter={[32, 16]}>
								<Col xs={24} sm={24} md={24} lg={12}>
									<Form.Item name="email" label={t(i18nKey.dashboard.accountInformation.emailAddress)}>
										<Input disabled />
									</Form.Item>
								</Col>
							</Row>
						</div>

						<div className={styles.subLevelForm}>
							<Row gutter={[32, 16]}>
								<Col span={24}>
									<Row>
										<Col span={24} className={styles.titleName}>
											{t(i18nKey.dashboard.accountInformation.residentAddressReg)}
										</Col>
									</Row>
									<Row>
										<Col span={24}>
											<div className={styles.dividerLine}></div>
										</Col>
									</Row>

									<Row gutter={[32, 16]}>
										<Col span={24}>
											<Form.Item
												name={['residentialAddress', 'addressLine']}
												label={`${t(i18nKey.dashboard.accountInformation.adrLine)}`}
												required={true}
												rules={[
													{
														required: true,
														message: `${t(i18nKey.onboarding.validation.required)}`
													}
												]}>
												<Input />
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={[32, 16]}>
										<Col span={24}>
											<Form.Item
												name={['residentialAddress', 'street']}
												label={`${t(i18nKey.dashboard.accountInformation.street)}`}
												required={true}
												rules={[
													{
														required: true,
														message: `${t(i18nKey.onboarding.validation.required)}`
													}
												]}>
												<Input />
											</Form.Item>
										</Col>
									</Row>
									<CountryDistrictSection
										countryName={['residentialAddress', 'country']}
										countryLabel={`${t(i18nKey.dashboard.accountInformation.country)}`}
										countryRules={[
											{
												required: true,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}
										districtName={['residentialAddress', 'district']}
										districtLabel={`${t(i18nKey.dashboard.accountInformation.district)}`}
										districtRules={[
											{
												required: true,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}
										requireCountry
										requireDistrict
									/>

									{!disableZipCode && (
										<Row gutter={[32, 16]}>
											<Col span={24}>
												<Form.Item
													name={['residentialAddress', 'zipCode']}
													label={`${t(i18nKey.dashboard.accountInformation.zipCode)}`}
													required={true}
													rules={[
														{
															required: true,
															message: `${t(i18nKey.onboarding.validation.required)}`
														},
														{
															pattern: ZIPCODE_REGEX,
															message: `${t(i18nKey.onboarding.validation.zipCode)}`
														}
													]}>
													<Input />
												</Form.Item>
											</Col>
										</Row>
									)}
									<Row>
										<div className="ant-col ant-form-item-label">
											<label htmlFor="">
												{t(i18nKey.dashboard.accountInformation.liveYears)}
												<span className={styles.requireAsterisk}>*</span>
											</label>
										</div>
									</Row>
									<Row gutter={8} className={styles.yearRow}>
										<Col xs={12} sm={12} md={12} lg={3}>
											<Form.Item
												name={['residentialAddress', 'livedTime']}
												required={false}
												normalize={normalizeInputBlockCharacter}
												rules={[
													{
														required: true,
														message: `${t(i18nKey.onboarding.validation.required)}`
													},
													{
														pattern: NUMBER_REGEX,
														message: `${t(i18nKey.onboarding.validation.bankAccount.required.onlyNumber)}`
													},
													{
														pattern: MAXIMUM_LIVED_YEAR_REGEX,
														message: `${t(i18nKey.onboarding.validation.accountDetail.required.maximumLiveYear)}`
													}
												]}>
												<Input />
											</Form.Item>
										</Col>
										<Col xs={12} sm={12} md={12} lg={4}>
											<Typography.Title level={4}>{t(i18nKey.dashboard.accountInformation.year)}</Typography.Title>
										</Col>
									</Row>
								</Col>
							</Row>
						</div>

						<div className={styles.subLevelForm}>
							<Row gutter={[32, 16]}>
								<Col span={24}>
									<Row>
										<Col span={24} className={styles.titleName}>
											{t(i18nKey.dashboard.accountInformation.mailingAddressReg)}
										</Col>
									</Row>
									<Row>
										<Col span={24}>
											<div className={styles.dividerLine}></div>
										</Col>
									</Row>

									<Row gutter={[32, 16]}>
										<Col span={24}>
											<Form.Item
												name={['mailingAddress', 'addressLine']}
												label={`${t(i18nKey.dashboard.accountInformation.adrLine)}`}>
												<Input />
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={[32, 16]}>
										<Col span={24}>
											<Form.Item
												name={['mailingAddress', 'street']}
												label={`${t(i18nKey.dashboard.accountInformation.street)}`}>
												<Input />
											</Form.Item>
										</Col>
									</Row>
									<CountryDistrictSection
										countryName={['mailingAddress', 'country']}
										countryLabel={`${t(i18nKey.dashboard.accountInformation.country)}`}
										districtName={['mailingAddress', 'district']}
										districtLabel={`${t(i18nKey.dashboard.accountInformation.district)}`}
									/>

									{!disableMailingZipCode && (
										<Row gutter={[32, 16]}>
											<Col span={24}>
												<Form.Item
													name={['mailingAddress', 'zipCode']}
													label={`${t(i18nKey.dashboard.accountInformation.zipCode)}`}
													rules={[
														{
															pattern: ZIPCODE_REGEX,
															message: `${t(i18nKey.onboarding.validation.zipCode)}`
														}
													]}>
													<Input disabled={disableMailingZipCode} />
												</Form.Item>
											</Col>
										</Row>
									)}
								</Col>
							</Row>
						</div>

						{/*  Employment Detail Section 	*/}
						<TitleBox style={{ backgroundColor: '#2CA6B8', color: '#FFFFFF' }}>
							<span>{t(i18nKey.onboarding.request.employmentDetail)}</span>
						</TitleBox>
						<div className={styles.subLevelForm}>
							<Row gutter={[32, 16]}>
								<Col xs={24} sm={24} md={24} lg={24}>
									<Form.Item
										name={['employmentDetail', 'employmentStatus']}
										label={`${t(i18nKey.onboarding.request.employment.employmentStatus)}`}
										rules={[
											{
												required: true,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<Radio.Group size="large" className={styles.radioSpace} onChange={onChangeEmploymentStatus}>
											<Row align={'middle'}>
												<Col xs={24} sm={12} md={12} lg={8} xl={6}>
													<Radio value={EMPLOYMENT_TYPE_CODE.employed}>
														{t(i18nKey.onboarding.request.employment.employed)}
													</Radio>
												</Col>
												<Col xs={24} sm={12} md={12} lg={8} xl={6}>
													<Radio value={EMPLOYMENT_TYPE_CODE.selfEmployed}>
														{t(i18nKey.onboarding.request.employment.selfEmployed)}
													</Radio>
												</Col>
												<Col xs={24} sm={12} md={12} lg={8} xl={6}>
													<Radio value={EMPLOYMENT_TYPE_CODE.retired}>
														{t(i18nKey.onboarding.request.employment.retired)}
													</Radio>
												</Col>
												<Col xs={24} sm={12} md={12} lg={8} xl={6}>
													<Row align={'middle'}>
														<Col sm={8} xs={24} md={8} lg={8} xl={8} xxl={6}>
															<Radio value={EMPLOYMENT_TYPE_CODE.others}>
																{t(i18nKey.onboarding.request.employment.others)}
															</Radio>
														</Col>
														{isShowEmploymentStatusOther && (
															<Form.Item
																name={['employmentDetail', 'employmentTypeOther']}
																noStyle
																rules={[
																	{
																		required: isShowEmploymentStatusOther,
																		message: `${t(i18nKey.onboarding.validation.required)}`
																	}
																]}>
																<Input className={styles.others} />
															</Form.Item>
														)}
													</Row>
												</Col>
											</Row>
										</Radio.Group>
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={[32, 16]}>
								<Col xs={24} sm={24} md={24} lg={24}>
									<Form.Item
										name={['employmentDetail', 'employmentType']}
										label={`${t(i18nKey.onboarding.request.employment.employmentType)}`}
										required={!isChooseRetiredOption}
										rules={[
											{
												required: !isChooseRetiredOption,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<Radio.Group size="large" className={styles.radioSpace} disabled={isChooseRetiredOption}>
											<Row>
												<Col xs={24} sm={12} md={6} lg={6}>
													<Radio value={'fulltime'}>{t(i18nKey.onboarding.request.employment.esFullTime)}</Radio>
												</Col>
												<Col xs={24} sm={12} md={6} lg={6}>
													<Radio value={'partTime'}>{t(i18nKey.onboarding.request.employment.esPartTime)}</Radio>
												</Col>
												<Col xs={24} sm={12} md={6} lg={6}>
													<Radio value={'contract'}>{t(i18nKey.onboarding.request.employment.esContract)}</Radio>
												</Col>
												<Col xs={24} sm={12} md={6} lg={6}>
													<Radio value={'casual/temp'}>{t(i18nKey.onboarding.request.employment.esCasualTemp)}</Radio>
												</Col>
											</Row>
										</Radio.Group>
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={[32, 16]}>
								<Col xs={24} sm={24} md={24} lg={12}>
									<Form.Item
										name={['employmentDetail', 'employerName']}
										normalize={normalizeInputBlockNumber}
										label={`${t(i18nKey.onboarding.request.employment.employerName)}`}
										rules={[
											{
												required: !isChooseRetiredOption,
												message: `${t(i18nKey.onboarding.validation.required)}`
											},
											{
												pattern: LETTER_REGEX,
												message: `${t(i18nKey.registration.validation.inputOnlyAlphabet)}`
											}
										]}
										required={!isChooseRetiredOption}>
										<Input placeholder="-" disabled={isChooseRetiredOption} />
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={24} lg={12}>
									<Form.Item
										name={['employmentDetail', 'natureOfBusiness']}
										normalize={normalizeInputBlockNumber}
										label={`${t(i18nKey.onboarding.request.employment.natureOfBiz)}`}
										rules={[
											{
												required: !isChooseRetiredOption,
												message: `${t(i18nKey.onboarding.validation.required)}`
											},
											{
												pattern: LETTER_REGEX,
												message: `${t(i18nKey.registration.validation.inputOnlyAlphabet)}`
											}
										]}
										required={!isChooseRetiredOption}>
										<Input placeholder="-" disabled={isChooseRetiredOption} />
									</Form.Item>
								</Col>
							</Row>
						</div>
						<div className={styles.subLevelForm}>
							<Row gutter={[32, 16]}>
								<Col xs={24} sm={24} md={24} lg={12}>
									<div>
										<Typography.Text className="styleLabelForm">
											{`${t(i18nKey.onboarding.request.employment.employerPhone)}`}
											{!isChooseRetiredOption && <span style={{ color: 'red' }}>*</span>}
											{/* <span style={{ color: 'red' }}>*</span> */}
										</Typography.Text>
										<Row gutter={[16, 16]}>
											<Col xs={9} sm={9} md={6} lg={11} xl={9} xxl={7}>
												<Form.Item
													name={['employmentDetail', 'employerPhoneExtension']}
													required={!isChooseRetiredOption}
													rules={[
														{
															validator: (_, values) => {
																if (!values && !isChooseRetiredOption) {
																	return Promise.reject(`${t(i18nKey.onboarding.validation.required)}`);
																}
																return Promise.resolve();
															}
														}
													]}>
													<Select
														placeholder={`${t(i18nKey.common.select)}`}
														options={applicationStore.phoneCountryCode}
														showSearch
														filterOption={(input, option) =>
															(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
														}
														disabled={isChooseRetiredOption}
													/>
												</Form.Item>
											</Col>
											<Col xs={15} sm={15} md={18} lg={13} xl={15} xxl={17}>
												<NumberInput
													noStyle={false}
													name={['employmentDetail', 'employerPhone']}
													rules={[
														{
															validator: (_, values) => {
																if (!values && !isChooseRetiredOption) {
																	return Promise.reject(`${t(i18nKey.onboarding.validation.required)}`);
																}
																return Promise.resolve();
															}
														}
													]}
													disabled={isChooseRetiredOption}
												/>
											</Col>
										</Row>
									</div>
								</Col>
								<Col xs={24} sm={24} md={24} lg={12}>
									<Form.Item
										name={['employmentDetail', 'annualSalary']}
										label={`${t(i18nKey.onboarding.request.employment.annualSalary)}`}
										required={!isChooseRetiredOption}
										normalize={normalizeNumberInput}
										rules={[
											{
												validator: (_, values) => {
													if (!values && !isChooseRetiredOption) {
														return Promise.reject(`${t(i18nKey.onboarding.validation.required)}`);
													}
													return Promise.resolve();
												}
											}
										]}>
										<Input disabled={isChooseRetiredOption} />
									</Form.Item>
								</Col>
							</Row>
						</div>
						<div className={styles.subLevelForm}>
							<Row gutter={[32, 16]}>{renderOccupation()}</Row>
							<Row gutter={[32, 16]}>
								<Col span={24}>
									<Row>
										<Col span={24} className={styles.titleName}>
											{t(i18nKey.onboarding.request.employment.employersAddress)}
										</Col>
									</Row>
									<Row>
										<Col span={24}>
											<div className={styles.dividerLine}></div>
										</Col>
									</Row>

									<Row gutter={[32, 16]}>
										<Col span={24}>
											<Form.Item
												name={['employmentDetail', 'addressLine']}
												label={`${t(i18nKey.dashboard.accountInformation.adrLine)}`}
												required={!isChooseRetiredOption}
												rules={[
													{
														validator: (_, values) => {
															if (!values && !isChooseRetiredOption) {
																return Promise.reject(`${t(i18nKey.onboarding.validation.required)}`);
															}
															return Promise.resolve();
														}
													}
												]}>
												<Input disabled={isChooseRetiredOption} />
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={[32, 16]}>
										<Col span={24}>
											<Form.Item
												name={['employmentDetail', 'street']}
												label={`${t(i18nKey.dashboard.accountInformation.street)}`}
												required={!isChooseRetiredOption}
												rules={[
													{
														validator: (_, values) => {
															if (!values && !isChooseRetiredOption) {
																return Promise.reject(`${t(i18nKey.onboarding.validation.required)}`);
															}
															return Promise.resolve();
														}
													}
												]}>
												<Input disabled={isChooseRetiredOption} />
											</Form.Item>
										</Col>
									</Row>
									<CountryDistrictSection
										countryName={['employmentDetail', 'country']}
										countryLabel={`${t(i18nKey.dashboard.accountInformation.country)}`}
										countryRules={[
											{
												validator: (_, values) => {
													if (!values && !isChooseRetiredOption) {
														return Promise.reject(`${t(i18nKey.onboarding.validation.required)}`);
													}
													return Promise.resolve();
												}
											}
										]}
										districtName={['employmentDetail', 'district']}
										districtLabel={`${t(i18nKey.dashboard.accountInformation.district)}`}
										districtRules={[
											{
												validator: (_, values) => {
													if (!values && !isChooseRetiredOption) {
														return Promise.reject(`${t(i18nKey.onboarding.validation.required)}`);
													}
													return Promise.resolve();
												}
											}
										]}
										requireCountry={!isChooseRetiredOption}
										requireDistrict={!isChooseRetiredOption}
										disabled={isChooseRetiredOption}
									/>
									{!disableZipCodeEmployerDetail && (
										<Row gutter={[32, 16]}>
											<Col span={24}>
												<Form.Item
													name={['employmentDetail', 'zipCode']}
													label={`${t(i18nKey.dashboard.accountInformation.zipCode)}`}
													required={!isChooseRetiredOption}
													rules={[
														{
															validator: (_, values) => {
																if (!values && !isChooseRetiredOption) {
																	return Promise.reject(`${t(i18nKey.onboarding.validation.required)}`);
																}
																return Promise.resolve();
															}
														},
														{
															pattern: ZIPCODE_REGEX,
															message: `${t(i18nKey.onboarding.validation.zipCode)}`
														}
													]}>
													<Input disabled={isChooseRetiredOption} />
												</Form.Item>
											</Col>
										</Row>
									)}
								</Col>
							</Row>
						</div>
					</Form>
				</Spin>
				<Row
					gutter={[
						{ xs: 0, sm: 0, md: 0, lg: 132 },
						{ xs: 20, sm: 20, md: 20, lg: 16 }
					]}>
					<Col span={24}>
						<Button block type="primary" onClick={onSaveClick} loading={saving}>
							{t(i18nKey.onboarding.saveAndNext)}
						</Button>
					</Col>
					<Col span={24}>
						<Button block type="primary" ghost onClick={onCancelClick}>
							{t(i18nKey.common.cancel)}
						</Button>
					</Col>
				</Row>
			</RegistrationWidget>
			<QuitConfirmPopup open={quitModalOpen} onClose={onModalClose} onQuit={onModalQuit} />
		</OnboardingPage>
	);
};

export default observer(IndividualAccountPage);
